export default __webpack_public_path__ + "static/media/chromeExtension.ed4ad3df.svg";